module.exports = __webpack_public_path__ + "img/contact.c7591fd6.svg";